var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88889 18.7778C14.7981 18.7778 18.7778 14.7981 18.7778 9.88889C18.7778 4.97969 14.7981 1 9.88889 1C4.97969 1 1 4.97969 1 9.88889C1 14.7981 4.97969 18.7778 9.88889 18.7778Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 20.9998L16.167 16.1665",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0864 7.46313L13.7274 8.73009H7.00269L7.36174 7.46313H14.0864ZM10.8138 15.4445L7.14118 10.987L7.13092 9.9868H8.95186C9.40667 9.9868 9.79138 9.9167 10.106 9.7765C10.4206 9.63629 10.66 9.43282 10.8241 9.16609C10.9882 8.89594 11.0703 8.56766 11.0703 8.18125C11.0703 7.60675 10.8993 7.15023 10.5574 6.81169C10.2154 6.47315 9.68024 6.30388 8.95186 6.30388H7.00269L7.37713 4.93945H8.95186C9.79993 4.93945 10.4992 5.07453 11.0498 5.34468C11.6004 5.61483 12.0107 5.98927 12.2809 6.46802C12.551 6.94677 12.6861 7.49903 12.6861 8.12482C12.6861 8.68222 12.5749 9.18661 12.3527 9.638C12.1304 10.0894 11.7765 10.457 11.2909 10.7408C10.8053 11.0247 10.1675 11.1905 9.37761 11.2384L9.33144 11.2486L12.6861 15.3573V15.4445H10.8138ZM14.0915 4.93945L13.7274 6.21668L8.35172 6.1859L8.71591 4.93945H14.0915Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIcon);
export default __webpack_public_path__ + "static/media/transactionIcon.bc377f99827f224832376916fc2d2605.svg";
export { ForwardRef as ReactComponent };